import React from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter as Router } from 'react-router-dom';
import Toast from '../toast';
import Routes from '../../routes';
import css from './index.scss';

const RootContainer = props => (
    <div className={css.rootContainer}>
        <Router basename={props.basename}>
            <Routes />
        </Router>
        <Toast />
    </div>
);

RootContainer.propTypes = {
    basename: PropTypes.string
};

export default RootContainer;



// WEBPACK FOOTER //
// ./app/components/root-container/index.js